<template>
  <v-dialog v-model="show" :max-width="maxWidth" @input="closeDialog" scrollable>
    <v-carousel v-model="modelIndex" hide-delimiters :show-arrows="documentArr.length > 1" :height="carrouselHeight">
      <v-carousel-item v-for="(item, i) in documentArr" :key="`${item.id}_${i}_${item.subtitle}-document`">
        <v-card elevation="0" class="fill-height">
          <v-card-title class="pb-4 text-h5 d-flex column-gap-2"
            >{{ item.title }}
            <v-spacer />
            <v-btn
              v-if="!hideDelete"
              @click="deleteDocument(item.id)"
              color="grey white--text"
              small
              fab
              elevation="0"
              class="delete-btn"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <v-btn :href="item.documentSrc" color="blue white--text" small fab elevation="1"
              ><v-icon>mdi-download</v-icon></v-btn
            >
          </v-card-title>

          <v-card-subtitle v-if="item.subtitle">{{ item.subtitle }}</v-card-subtitle>
          <v-card-text v-if="['JPG', 'PNG'].indexOf()" class="fill-height">
            <v-img :src="item.documentSrc" contain class="img-height" />
          </v-card-text>
        </v-card>
      </v-carousel-item>
    </v-carousel>
  </v-dialog>
</template>

<script>
export default {
  name: 'ReferenceDocumentDialog',
  props: {
    maxWidth: {
      type: [String, Number],
      default: '60vw',
    },
    hideDelete: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      documentArr: [],
      modelIndex: 0,
    }
  },

  computed: {
    carrouselHeight() {
      const isImg = !!this.documentArr.find((item) => ['JPG', 'PNG'].includes(item.extension))
      return isImg ? '90vh' : '100%'
    },
  },

  methods: {
    openDialog(document, clickedId = 0) {
      this.show = true

      if (!Array.isArray(document)) {
        this.documentArr = [
          {
            description: document.description ?? '',
            documentSrc: document.url,
            title: `Data de referência: ${
              document.referenceDate ? this.$moment(document.referenceDate).format('DD/MM/YYYY') : 'Não informado'
            }`,
            subtitle: document.description,
            id: document.id,
            extension: document.extension,
          },
        ]

        this.modelIndex = 0
      } else {
        document.forEach((item) => {
          this.documentArr.push({
            description: item.description ?? '',
            documentSrc: item.url,
            title: `Data de referência: ${
              document.referenceDate ? this.$moment(document.referenceDate).format('DD/MM/YYYY') : 'Não informado'
            }`,
            subtitle: item.description,
            id: item.id,
            extension: item.extension,
          })
        })

        const currentItem = document.findIndex((item) => item.id == clickedId)
        this.modelIndex = currentItem >= 0 ? currentItem : 0
      }
    },
    closeDialog() {
      this.show = false

      this.documentArr = []
    },
    async deleteDocument(id) {
      await this.$api.removePatientAttendanceFile(id)

      this.show = false
      this.documentArr = []
      this.$nextTick(() => {
        this.$emit('document-deleted')
      })
    },
  },
}
</script>

<style scoped>
:deep(.delete-btn:hover) {
  color: red;
}

.img-height {
  max-height: calc(100% - 124px);
}
</style>
